(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.common.formly.inputs.file-upload'
  const templateUrl = require('./tpl/file-upload.html')
  const Hashids = require('hashids')

  require('angular-file-upload')
  require('angular-uuid4')
  require('./scss/file-upload.scss')

  require('angular')
    .module(MODULE_NAME, [
      'uuid4',
      'angularFileUpload', // ಠ_ಠ
      require('angular-animate'),
      require('angular-formly'),
      require('angular-formly-templates-bootstrap'),
      require('angular-ui-bootstrap/src/progressbar'),
      require('./service/media-processor')
    ])
    .constant('MicrosoftFileTypes', [
      'application/msword',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ])
    .constant('FormlyUploadStrings', {
      en: {
        'FORMLY.UPLOAD.LABEL': 'Upload',
        'FORMLY.UPLOAD.UPLOADING': 'Uploading file...',
        'FORMLY.UPLOAD.PROCESSING': 'Processing file...',
        'FORMLY.UPLOAD.CTA': 'Please upload your file(s)',
        'FORMLY.UPLOAD.VIDEO.DONE': 'video uploaded',
        'FORMLY.UPLOAD.UPLOAD.BUTTON': 'Upload File',
        'FORMLY.UPLOAD.REMOVE.BUTTON': 'Remove',
        'FORMLY.UPLOAD.MULTIMEDIA.BUTTON': 'add more media',
        'FORMLY.UPLOAD.INVALID': 'Invalid file type. Please review allowable file types and re-submit.',
        'FORMLY.UPLOAD.ERROR': 'Could not process this file. Please try again later.'
      },
      es: {
        'FORMLY.UPLOAD.LABEL': 'Archivo',
        'FORMLY.UPLOAD.UPLOADING': 'cargando archivo',
        'FORMLY.UPLOAD.PROCESSING': 'archivo procesando',
        'FORMLY.UPLOAD.CTA': 'por favor suba su archivo',
        'FORMLY.UPLOAD.VIDEO.DONE': 'video subido',
        'FORMLY.UPLOAD.UPLOAD.BUTTON': 'subir archivo',
        'FORMLY.UPLOAD.REMOVE.BUTTON': 'borrar',
        'FORMLY.UPLOAD.MULTIMEDIA.BUTTON': 'agregar mas archivos',
        'FORMLY.UPLOAD.INVALID': '',
        'FORMLY.UPLOAD.ERROR': 'No se puede procesar el archivo.  Favor de intentar mas tarde.'
      },
      fr: {
        'FORMLY.UPLOAD.LABEL': 'Upload',
        'FORMLY.UPLOAD.UPLOADING': 'téléchargement de fichier',
        'FORMLY.UPLOAD.PROCESSING': 'fichier de traitement',
        'FORMLY.UPLOAD.CTA': 'partagez vos videos',
        'FORMLY.UPLOAD.VIDEO.DONE': 'vidéo téléchargée',
        'FORMLY.UPLOAD.UPLOAD.BUTTON': 'téléverser un fichier',
        'FORMLY.UPLOAD.REMOVE.BUTTON': 'annuler',
        'FORMLY.UPLOAD.MULTIMEDIA.BUTTON': 'ajouter plus de médias',
        'FORMLY.UPLOAD.INVALID': '',
        'FORMLY.UPLOAD.ERROR': 'Impossible de traiter ce fichier. Veuillez réessayer plus tard.'
      },
      jp: {
        'FORMLY.UPLOAD.LABEL': 'Upload',
        'FORMLY.UPLOAD.UPLOADING': 'ファイルをアップロードする',
        'FORMLY.UPLOAD.PROCESSING': 'アップロード中…',
        'FORMLY.UPLOAD.CTA': 'あなたのファイルをアップロードしてください',
        'FORMLY.UPLOAD.VIDEO.DONE': 'ビデオがアップロードされました',
        'FORMLY.UPLOAD.UPLOAD.BUTTON': 'ファイルアップロード',
        'FORMLY.UPLOAD.REMOVE.BUTTON': '削除する',
        'FORMLY.UPLOAD.MULTIMEDIA.BUTTON': 'メディアを追加する',
        'FORMLY.UPLOAD.INVALID': '',
        'FORMLY.UPLOAD.ERROR': 'アップロードに失敗しました。後ほど再度お試し下さい。'
      },
      it: {
        'FORMLY.UPLOAD.LABEL': 'Carica File',
        'FORMLY.UPLOAD.UPLOADING': 'Caricamento del file…',
        'FORMLY.UPLOAD.PROCESSING': 'Elaborazione del file…',
        'FORMLY.UPLOAD.CTA': 'Carica il tuo file',
        'FORMLY.UPLOAD.VIDEO.DONE': 'Video caricato',
        'FORMLY.UPLOAD.UPLOAD.BUTTON': 'Carica file',
        'FORMLY.UPLOAD.REMOVE.BUTTON': 'Rimuovi',
        'FORMLY.UPLOAD.MULTIMEDIA.BUTTON': 'aggiungi più media',
        'FORMLY.UPLOAD.INVALID': '',
        'FORMLY.UPLOAD.ERROR': 'Impossibile processare il file. Riprova più tardi.'
      }
    })
    .run(fileUploadConfig)

  fileUploadConfig.$inject = ['formlyConfig']
  function fileUploadConfig (formlyConfig) {
    formlyConfig.setType({
      name: 'file-upload',
      templateUrl: templateUrl,
      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
      defaultOptions: {
        templateOptions: {
          uploadConfig: {
            autoUpload: true,
            removeAfterUpload: true,
            queueLimit: 1
          }
        },
        // this is here so that formly does not insert the various ARIA attributes on the wrapper
        // so that the <input>s in the template can handle them
        templateManipulators: {
          preWrapper: [function (template, options, scope) {
            template = template.replace('ng-model', 'data-ng-model')
            return template
          }]
        }
      },
      controller: fileUploadController
    })
  }

  fileUploadController.$inject = ['$scope', 'uuid4', 'FileUploader', 'FormlyUploadStrings', 'MicrosoftFileTypes', 'SdkConfig', 'MediaProcessor']
  function fileUploadController ($scope, uuid4, FileUploader, FormlyUploadStrings, MicrosoftFileTypes, SdkConfig, MediaProcessor) {
    var uploader = $scope.uploader = new FileUploader(
      angular.merge({}, $scope.options.templateOptions.uploadConfig, {
        url: SdkConfig.get('file_upload_url')
      })
    )
    var value = $scope.model[$scope.name]
    var allowedExtensions = []
    var allowedMimeTypes = []

    // TODO: already existing item?

    /*
     * So why files, fileStates, AND the model you may ask...
     * This is done in order to allow for
     * multiple file inputs on a single component,
     * following the advise of the angular-file-upload
     * author, see https://github.com/nervgh/angular-file-upload/issues/642
     */
    $scope.files = []
    $scope.fileStates = {}
    $scope.$on('formly:resetForm', function () {
      $scope.files = []
      $scope.fileStates = {}
      if ($scope.options.templateOptions.multiUploadEnable) {
        var initialUploaders = $scope.options.templateOptions.multiUploadMin || 1
        for (var i = 0; i < initialUploaders; i++) {
          addFileUpload()
        }
      } else {
        addFileUpload()
      }

      updateModel()
    })

    if (angular.isUndefined($scope.to.multiUploadEnable) || $scope.to.multiUploadEnable === false) {
      $scope.to.multiUploadMax = 1
    }

    if (value) {
      var file = (angular.isObject(value)) ? value : unpackFileObject(value)
      var newFile = {
        id: uuid4.generate(),
        fileUrl: file.url,
        filePreview: file.url,
        fileName: file.name,
        hasImage: true, // right now we only save images, i.e. spark settings
        hasVideo: false,
        media: value
      }

      $scope.files.push({
        id: newFile.id
      })
      $scope.fileStates[newFile.id] = newFile
      updateModel()
    } else if ($scope.options.templateOptions.multiUploadEnable) {
      var initialUploaders = $scope.options.templateOptions.multiUploadMin || 1
      // init uploader with a single file uploader
      for (var i = 0; i < initialUploaders; i++) {
        addFileUpload()
      }
    } else {
      addFileUpload()
    }

    $scope.addFileUpload = addFileUpload
    $scope.removeFileUpload = removeFileUpload

    $scope.strings = FormlyUploadStrings[SdkConfig.get('language')]
    $scope.removeFile = removeFile
    $scope.accessibleButton = $scope.options.templateOptions.accessibleButton
    $scope.styles = {}

    if (!$scope.accessibleButton) {
      $scope.styles.button = {
        opacity: 0,
        position: 'absolute',
        top: 0,
        left: 0
      }
    }

    // FILTERS
    // TODO: Move filters to separate file
    uploader.filters.push({
      name: 'isFile',
      fn: function filterIsFile (item /* {File|FileLikeObject} */, options) {
        return this.isFile(item)
      }
    })

    uploader.filters.push({
      name: 'queueLimit',
      fn: function filterQueueLimit (item /* {File|FileLikeObject} */, options) {
        return this.queue.length <= this.queueLimit
      }
    })

    angular.forEach(uploader.useFilters, function useFilters (filter) {
      switch (filter) {
        case 'restrictImage':
          allowedExtensions = allowedExtensions.concat([
            '.bmp',
            '.gif',
            '.jpeg',
            '.jpg',
            '.png'
          ])
          allowedMimeTypes = allowedMimeTypes.concat([
            'image/bmp',
            'image/gif',
            'image/jpeg',
            'image/png',
            'image/vnd.microsoft.icon'
          ])
          break

        case 'restrictVideo':
          allowedExtensions = allowedExtensions.concat([
            '.avi',
            '.mov',
            '.mp4',
            '.mpeg',
            '.mpg',
            '.wmv'
          ])
          allowedMimeTypes = allowedMimeTypes.concat([
            'video/avi',
            'video/mp4',
            'video/mpeg',
            'video/quicktime',
            'video/x-ms-wmv',
            'video/x-msvideo'
          ])
          break

        case 'restrictDoc':
          allowedExtensions = allowedExtensions.concat([
            '.docx',
            '.msword',
            '.pdf',
            '.pptx',
            '.xlsx'
          ])
          allowedMimeTypes = allowedMimeTypes.concat([
            'application/msword',
            'application/pdf',
            'application/vnd.ms-excel',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          ])
          break

        case 'restrictCsv':
          allowedExtensions = allowedExtensions.concat([
            '.csv'
          ])
          allowedMimeTypes = allowedMimeTypes.concat([
            'text/csv'
          ])
          break
      }
      $scope.accept = allowedExtensions.join(',')
    })

    // CALLBACKS
    uploader.onWhenAddingFileFailed = cbOnWhenAddingFileFailed
    uploader.onAfterAddingFile = cbOnAfterAddingFile
    uploader.onBeforeUploadItem = cbOnBeforeUploadItem
    uploader.onProgressItem = cbOnProgressItem
    uploader.onSuccessItem = cbOnSuccessItem
    uploader.onErrorItem = cbOnErrorItem

    // FUNCTIONS
    function addFileUpload ($event) {
      if ($scope.files.length >= $scope.to.multiUploadMax) {
        return
      }

      // stub
      var newFile = {
        id: uuid4.generate(),
        fileUrl: null,
        fileName: null,
        hasImage: false,
        hasVideo: false,
        uploadInProgress: false,
        uploadProgress: null,
        uploadMessage: null
      }

      // for `ng-repeat` to allow easy access to the files state values
      $scope.files.push({
        id: newFile.id
      })

      // for tracking file state
      $scope.fileStates[newFile.id] = newFile

      if (typeof $event !== 'undefined') { // don't perform this if the form is init'n
        // prevent formly from interpretting this as a $submit event
        $event.preventDefault()
        updateModel()
      }
    }

    function removeFileUpload (fileId) {
      angular.forEach($scope.files, function (file, idx) {
        if (file.id === fileId) {
          $scope.files.splice(idx, 1)
        }
      })
      delete $scope.fileStates[fileId]
      updateModel()
    }

    function cbOnWhenAddingFileFailed (item /* {File|FileLikeObject} */, filter, options) {
      // TODO: Error state for failure.
      console.info('onWhenAddingFileFailed', item, filter, options)
    }

    function cbOnAfterAddingFile (fileItem) {
      var fileType = fileItem.file.type
      if (allowedMimeTypes.indexOf(fileType) === -1) {
        fileItem.remove()
        $scope.fileStates[fileItem.id].isInvalid = true
        removeFile(fileItem.id)
        document.getElementById('file-picker-' + fileItem.id).value = ''
        return
      }

      var file = fileItem.file
      var accountId = ($scope.to.accountId) ? $scope.to.accountId : SdkConfig.get('account_id')

      $scope.fileStates[fileItem.id].isInvalid = false
      fileItem.formData = [
        {'x-amz-meta-account-id': accountId},
        {success_action_status: 201},
        {acl: 'bucket-owner-full-control'},
        {key: 'upload/' + accountId + '/' + generateFileKey(file.name)},
        {'x-amz-meta-filename': file.name.replace(/[^0-9a-zA-Z.]+/g, '-')},
        {'x-amz-meta-filetype': file.type}
      ]
    }

    function cbOnBeforeUploadItem (fileItem) {
      $scope.fileStates[fileItem.id].uploadInProgress = true
      $scope.fileStates[fileItem.id].uploadProgress = 0
      $scope.fileStates[fileItem.id].uploadMessage = $scope.strings['FORMLY.UPLOAD.UPLOADING']
      $scope.fileStates[fileItem.id].barType = 'success'
    }

    function cbOnProgressItem (fileItem, progress) {
      $scope.fileStates[fileItem.id].uploadProgress = progress
    }

    function cbOnSuccessItem (fileItem, response, status, headers) {
      // parse response
      var parser = new DOMParser()
      var xml = parser.parseFromString(response, 'text/xml')
      var postData = {
        account_id: ($scope.to.accountId) ? $scope.to.accountId : SdkConfig.get('account_id'),
        bucket: xml.querySelector('PostResponse Bucket').innerHTML,
        env_host: SdkConfig.get('env_host'),
        etag: xml.querySelector('PostResponse ETag').innerHTML,
        key: xml.querySelector('PostResponse Key').innerHTML,
        location: xml.querySelector('PostResponse Location').innerHTML
      }

      $scope.fileStates[fileItem.id].uploadMessage = $scope.strings['FORMLY.UPLOAD.PROCESSING']

      MediaProcessor.process({}, postData, processorWin, processorFail)

      function processorWin (response) {
        var fileObj = response.data.result
        var type = fileObj.metadata.type

        $scope.fileStates[fileItem.id].media = packFileObject(fileObj)
        $scope.fileStates[fileItem.id].fileUrl = fileObj.orig_file
        $scope.fileStates[fileItem.id].filePreview = fileObj.small
        $scope.fileStates[fileItem.id].fileName = fileObj.metadata.name
        $scope.fileStates[fileItem.id].uploadInProgress = false
        updateModel()

        if (type.indexOf('image/') > -1) {
          $scope.fileStates[fileItem.id].hasImage = true
        } else if (type.indexOf('video/') > -1) {
          $scope.fileStates[fileItem.id].hasVideo = true
        } else if (type.indexOf('/pdf') > -1) {
          $scope.fileStates[fileItem.id].hasImage = true
        } else if (type.indexOf('/csv') > -1) {
          $scope.fileStates[fileItem.id].hasImage = true
        } else if (MicrosoftFileTypes.includes(type)) {
          $scope.fileStates[fileItem.id].hasImage = true
        }
      }

      function processorFail (response) {
        setUploadError(fileItem.id, $scope.strings['FORMLY.UPLOAD.ERROR'])
      }
    }

    function cbOnErrorItem (fileItem, response, status, headers) {
      setUploadError(fileItem.id, $scope.strings['FORMLY.UPLOAD.ERROR'])
    }

    function generateFileKey (fileName) {
      var HashConstructor = Hashids.default
      var hashids = new HashConstructor(($scope.to.accountId) ? $scope.to.accountId : SdkConfig.get('account_id') + ':' + fileName + ':' + new Date().toISOString(), 32)

      return hashids.encode(Math.floor((Math.random() * 100000) + 1))
    }

    function packFileObject (fileJSON) {
      if (fileJSON === null) {
        return null
      } else {
        return JSON.stringify(fileJSON)
      }
    }

    function removeFile (fileId) {
      $scope.fileStates[fileId].hasImage = false
      $scope.fileStates[fileId].hasVideo = false
      $scope.fileStates[fileId].fileUrl = null
      $scope.fileStates[fileId].fileName = null
      $scope.fileStates[fileId].media = null
      var fileInput = document.getElementById('file-picker-' + fileId)
      if (fileInput) {
        fileInput.value = ''
      }
      updateModel()
    }

    function setUploadError (fileId, message) {
      $scope.fileStates[fileId].barType = 'danger'
      $scope.fileStates[fileId].uploadProgress = 100
      $scope.fileStates[fileId].uploadMessage = message
    }

    function unpackFileObject (rawData) {
      if (angular.isUndefined(rawData) || rawData === null || rawData.length === 0) {
        return null
      } else {
        var fileUrl = JSON.parse(rawData).orig_file
        var _file = fileUrl.split('/')
        var filename = _file[_file.length - 1]

        return {
          url: fileUrl,
          name: filename
        }
      }
    }

    /*
     * A note on this function:
     * `file-upload` now allows users to optionally add
     * multiple file inputs to their submission. Validation
     * of this is complex (e.g. a user adds two file inputs
     * but only uploads one file). Several attempts at using angular's
     * angular's built-in validation have thus far not been able to cover all
     * bases. The only sure-fire way identified, as of this writing,
     * is to simply blow away the file model if the inputs are invalid;
     * we have the `fileState` and can thus re-construct
     * the model whenever it is valid and ready to submit. This
     * "validation" thus falls back on angular's `required`
     * check.
     *
     * There is surely a better way to do this.
     */
    function updateModel () {
      var fileStatesWithMedia = []
      // how many inputs have a valid media file
      angular.forEach($scope.fileStates, function (fileState) {
        if (fileState.media) {
          fileStatesWithMedia.push(fileState.media)
        }
      })

      // has the user uploaded a piece of media to each input?
      if (fileStatesWithMedia.length === $scope.files.length) {
        // we are valid so let's make a final model!
        $scope.model[$scope.name] = fileStatesWithMedia
      } else {
        // we are invalid so let's destroy the model
        $scope.model[$scope.name] = null
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/inputs/file-upload.js